'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addressView = exports.addressOptions = exports.addressLookup = exports.addressFields = undefined;
var _constants = require('../constants');
var addressFields = exports.addressFields = function addressFields(state, formId, addressId) {
  return {
    line1: state[_constants.NAME][formId].values[addressId + 'Line1'] || '',
    line2: state[_constants.NAME][formId].values[addressId + 'Line2'] || '',
    townCity: state[_constants.NAME][formId].values[addressId + 'TownCity'] || '',
    county: state[_constants.NAME][formId].values[addressId + 'County'] || '',
    postcode: state[_constants.NAME][formId].values[addressId + 'Postcode'] || ''
  };
};
var addressLookup = exports.addressLookup = function addressLookup(state, formId) {
  return state[_constants.NAME][formId] ? state[_constants.NAME][formId].addressLookup : {};
};
var addressOptions = exports.addressOptions = function addressOptions(state, formId, addressId) {
  return state[_constants.NAME][formId].addressLookup[addressId].options;
};
var addressView = exports.addressView = function addressView(state, formId, addressId) {
  return state[_constants.NAME][formId].addressLookup && state[_constants.NAME][formId].addressLookup[addressId] ? state[_constants.NAME][formId].addressLookup[addressId].visible : 'lookup';
};